/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from '../../../components/Table/Table';
import TableContainer from '../../../components/TableContainer/TableContainer';
import TableBody from '../../../components/TableBody/TableBody';
import TableRow from '../../../components/TableRow/TableRow';
import TableCell from '../../../components/TableCell/TableCell';
import TableBtnSets from '../../../components/ConfigTable/TableBtnSets';
import TableHead from '../../../components/TableHead/TableHead';
import MaterialTypeUpdateDialog from './MaterialTypeUpdateDialog/MaterialTypeUpdateDialog';

const SettingConfigMaterialTypeTableHeadCells = [
  { id: 'materialName', numeric: false, disablePadding: true, label: '材質' },
];

const ConfigTable = ({ tableContentList, editedData, isLoading }) => {
  const [targetEditRow, setTargetEditRow] = useState(null);

  const handleOpenEditDialog = (targetRow) => {
    setTargetEditRow(targetRow);
  };

  const handleCloseEditDialog = () => {
    setTargetEditRow(null);
  };

  return (
    <TableContainer isLoading={isLoading} sx={{ mt: 4, mb: 2 }}>
      <Table>
        <TableHead isCheckBox={false} headCells={SettingConfigMaterialTypeTableHeadCells} />
        <TableBody>
          {tableContentList.map((row) => (
            <TableRow
              tabIndex={-1}
              key={row.materialId}
              style={{ verticalAlign: editedData?.error ? 'top' : 'middle' }}
            >
              <TableCell>{row.materialName}</TableCell>
              <TableCell align="right">
                <TableBtnSets
                  handleView={() => handleOpenEditDialog(row)}
                  isView
                  isDelete={false}
                  iDelete={false}
                  isEditing={false}
                  canEdit={false}
                  buttonProps={{
                    view: { sx: { '&.MuiIconButton-root': { color: 'primary.main' } } },
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {targetEditRow !== null && (
        <MaterialTypeUpdateDialog
          isOpen={targetEditRow !== null}
          onClose={handleCloseEditDialog}
          targetRow={targetEditRow}
        />
      )}
    </TableContainer>
  );
};

ConfigTable.propTypes = {
  isLoading: PropTypes.bool,
  tableContentList: PropTypes.array.isRequired,
  editedData: PropTypes.object,
};

export default ConfigTable;
